var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, ManyToOne, PrimaryColumn } from 'typeorm';
import { Asset } from './asset.js';
import { Domain } from './domain.js';
import { Root } from './root.js';
import { Test } from './test.js';
class BaseAnalysis {
    id;
    createdDate;
    project;
    context;
}
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], BaseAnalysis.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], BaseAnalysis.prototype, "createdDate", void 0);
__decorate([
    ManyToOne('Project', { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], BaseAnalysis.prototype, "project", void 0);
__decorate([
    Column('uuid', { array: true, default: () => 'ARRAY[]::uuid[]' }),
    __metadata("design:type", Array)
], BaseAnalysis.prototype, "context", void 0);
let WebAnalysis = class WebAnalysis extends BaseAnalysis {
    test;
    snapshot;
};
__decorate([
    ManyToOne(() => Test, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Test)
], WebAnalysis.prototype, "test", void 0);
__decorate([
    ManyToOne('HTTPSnapshot', { nullable: false, createForeignKeyConstraints: false }),
    __metadata("design:type", Function)
], WebAnalysis.prototype, "snapshot", void 0);
WebAnalysis = __decorate([
    Entity({ name: 'web_analyses' }),
    Index('idx_web_project_test_created', ['project', 'test', 'createdDate']),
    Index('idx_web_snapshot_created', ['snapshot', 'createdDate']),
    Index('idx_web_project', ['project'])
], WebAnalysis);
export { WebAnalysis };
let DNSAnalysis = class DNSAnalysis extends BaseAnalysis {
    domain;
    snapshot;
};
__decorate([
    ManyToOne(() => Domain, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Domain)
], DNSAnalysis.prototype, "domain", void 0);
__decorate([
    ManyToOne('DNSSnapshot', { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], DNSAnalysis.prototype, "snapshot", void 0);
DNSAnalysis = __decorate([
    Entity({ name: 'dns_analyses' }),
    Index('idx_dns_project_domain_created', ['project', 'domain', 'createdDate']),
    Index('idx_dns_snapshot_created', ['snapshot', 'createdDate']),
    Index('idx_dns_project', ['project'])
], DNSAnalysis);
export { DNSAnalysis };
let CertificateAnalysis = class CertificateAnalysis extends BaseAnalysis {
    resource;
    snapshot;
};
__decorate([
    ManyToOne(() => Asset, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Asset)
], CertificateAnalysis.prototype, "resource", void 0);
__decorate([
    ManyToOne('CertificateSnapshot', { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], CertificateAnalysis.prototype, "snapshot", void 0);
CertificateAnalysis = __decorate([
    Entity({ name: 'certificate_analyses' }),
    Index('idx_certificate_project_resource_created', ['project', 'resource', 'createdDate']),
    Index('idx_certificate_snapshot_created', ['snapshot', 'createdDate']),
    Index('idx_certificate_project', ['project'])
], CertificateAnalysis);
export { CertificateAnalysis };
let TransparencyAnalysis = class TransparencyAnalysis extends BaseAnalysis {
    root;
    snapshot;
};
__decorate([
    ManyToOne(() => Root, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Root)
], TransparencyAnalysis.prototype, "root", void 0);
__decorate([
    ManyToOne('CTSnapshot', { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], TransparencyAnalysis.prototype, "snapshot", void 0);
TransparencyAnalysis = __decorate([
    Entity({ name: 'transparency_analyses' }),
    Index('idx_transparency_project_root_created', ['project', 'root', 'createdDate']),
    Index('idx_transparency_snapshot_created', ['snapshot', 'createdDate']),
    Index('idx_transparency_project', ['project'])
], TransparencyAnalysis);
export { TransparencyAnalysis };
//# sourceMappingURL=data:application/json;base64,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